import React from 'react'

const PreviewSurvey = () => {
return (
    <div>PreviewSurvey</div>
  )
}

export default PreviewSurvey